import utils from "../utils";

window.accordionToggle = function (button){

	var accordions = document.querySelectorAll('.accordion'),
		tabIndex = button.getAttribute('data-index'),
		parent = button.parentElement;

	if(accordions.length > 0){
		utils.forEach(accordions, function (index, accordion) {
			if(tabIndex){
				if(tabIndex != index){
					accordion.classList.add('close');
				}
			}
		});
	}

	parent.classList.toggle('close');

}

window.accordionTrigger = function (button){

	var accordion = button.parentElement;
	
	accordion.classList.toggle('open');

}

function init(){

	var accordionsBody = document.querySelectorAll('.accordion .accordion-body');

	if(accordionsBody.length > 0){
		utils.forEach(accordionsBody, function (index, accordionBody) {
			var realHeight = accordionBody.scrollHeight;
			accordionBody.style.maxHeight = realHeight + 'px';
		});
	}

}

export default {
	init,
};